export default __webpack_public_path__ + "static/exoticLogo-007dc606ec8a3e7d3e3b4edd167185e1.png";